export const capitalizeText = (text: string) => {
  if (!text) return "";

  return text
    .replace(/-/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};
